/**
 * 仕込みの取り込み(#250)が失敗したときの読み解き。
 *
 * 失敗には2種類ある。
 *   - 記載なし: 選んだ文書に作り方が書かれていなかった。**同じ文書で取り込み直しても直らない**
 *   - それ以外: 通信・起動などの失敗。もう一度実行すれば直りうる
 * 両者を同じ「失敗しました」で出すと、利用者は取り込み直しを繰り返して行き止まりになる
 * (揚げマナガツオの「揚げにんにく」)。画面は種類ごとに次の手を出し分ける。
 *
 * 種類はワーカーが errorKind に書く(worker/lib/failure.mjs)。この欄が入る前の
 * ジョブもあるので、無ければ CLI の文言(src/commands/prep.ts の prepDocNotFoundMessage)で見分ける。
 */
import type { FailureKind } from "./types";

export interface PrepFailure {
  /** 文書に作り方が書かれていなかった(再実行では直らない) */
  notFound: boolean;
  /** 利用者に見せる補足。記載なしなら文書を読んだ結果、それ以外はエラーの要点。無ければ null */
  detail: string | null;
}

const NOT_FOUND = /の作り方が見つかりませんでした/;
/** CLI の文言「…見つかりませんでした。(文書を読んだ結果)別の文書を選ぶか…」から括弧の中身を取る */
const SOURCE = /見つかりませんでした。\((.*)\)別の文書を選ぶか/s;

export function prepFailureOf(job: { error: string | null; errorKind?: FailureKind | null }): PrepFailure {
  const error = job.error ?? "";
  if (job.errorKind === "prep-doc-not-found" || NOT_FOUND.test(error)) {
    const m = SOURCE.exec(error);
    return { notFound: true, detail: m ? m[1].trim() || null : null };
  }
  // 記載なし以外は、❌ の行(CLI の要約)を優先して出す。長い標準エラーは見せても読めない
  const line = error.split("\n").find((l) => l.includes("❌"));
  const detail = (line ?? error).replace(/^\s*❌\s*(エラー:\s*)?/, "").trim();
  return { notFound: false, detail: detail ? detail.slice(0, 200) : null };
}
